import React from 'react';

const AfricanPattern = () => (
  <svg className="pattern-bg" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <pattern id="africanPattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
        <path d="M0,50 L25,25 L50,50 L25,75 Z M50,0 L75,25 L50,50 L25,25 Z M50,50 L75,75 L50,100 L25,75 Z" 
              fill="none" stroke="rgba(218, 165, 32, 0.1)" strokeWidth="1"/>
        <circle cx="50" cy="50" r="3" fill="rgba(139, 69, 19, 0.15)"/>
      </pattern>
    </defs>
    <rect width="100%" height="100%" fill="url(#africanPattern)"/>
  </svg>
);

export default AfricanPattern;
